<div id="searchContainer">
    <div id="inputForm">
        <mat-label class="word">Was ist der Artikel für&nbsp;</mat-label>
        <input #search matInput id="wordInput" type="search" (keyup)="onKey(search.value)" [cdkTrapFocusAutoCapture]="true"
            [cdkTrapFocus]="true">
    </div>
</div>
@if (results.length !== 0) {
<div id="resultsRow">
    <div id="resultsContainer">
        @for(res of results; track res.word) {
        <span>
            <span id="article" [class.der]="res.article == 'der'" [class.die]="res.article == 'die'"
                [class.das]="res.article == 'das'">{{res.article}}</span>
            &nbsp;
            <span class="word">{{res.word}}</span>
            &nbsp;
        </span>
        }
    </div>
</div>
}